import React from 'react';

const Centered = (props) => {
  const [open, setOpen] = React.useState(true);
  const { maincard } = props;
  return (
    <div className="flex min-h-screen w-full flex-col self-center justify-self-center overflow-hidden lg:mx-0">
      {/* <NavbarAuth onOpenSidenav={() => setOpen(!open)} /> */}
      {/* <FixedPlugin /> */}
      <div className="absolute left-0 right-0 top-0 max-h-[48vh] min-h-[48vh] w-full overflow-hidden bg-gradient-to-br from-brand-400 to-brand-600 bg-cover bg-no-repeat md:mx-auto" />
      {/* bgImage={image} */}
      {maincard}
    </div>
  );
};

export default Centered;
